module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_134010-1207937700.450a7d6b.jpg";